import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const NewBtn = ({ icon, text = null, ...others }) => {
  return (
    <Button
      color="primary"
      variant="solid"
      icon={!icon ? <PlusOutlined /> : null}
      {...others}
    >
      {text == null ? "Nuevo" : text}
    </Button>
  );
};
